import { gql } from '@/shared/graphql/generated/explorer';

export const getEvmStateChainCall = gql(/* GraphQL */ `
  query GetEvmStateChainCallByTxHash($txHash: String!) {
    call: evmStateChainCallByTxHash(txHash: $txHash) {
      success
      error: stateChainErrorByStateChainErrorId {
        name
        docs
      }
    }
  }
`);
